import { useCurrencies, useOrganizationDefaults } from '@/modules/common/hooks';

/**
 * Hook to manage loading states for project-related dependencies
 * (currencies, organization defaults)
 *
 * Note: Industries are fetched during project details loading (getProjectDetails)
 * and cached by TanStack Query. IndustrySelect reads from that cache directly.
 * Clients and managers are loaded via pagination in the form selectors.
 *
 * All queries are configured to not retry on error and to fail gracefully.
 * This ensures that if any dependency fails to load, the user can still view/edit the project.
 */
export function useProjectDependencies() {
  // TODO Custom attributes query is commented out — feature is postponed, no need to load from backend
  // const customAttributesQuery = useQuery({
  //   queryKey: ['custom-attributes'],
  //   queryFn: getCustomAttributes,
  // });

  const { currencies, isLoadingCurrencies, currenciesError } = useCurrencies();

  const organizationDefaultsQuery = useOrganizationDefaults();

  // IMPORTANT: isLoading should be false to not block the page
  // All dependencies are optional - users should be able to view/edit projects even if dependencies fail
  // Individual loading states are available below for each dependency
  const isLoading = false;

  // Track errors separately - don't block the page, just show empty values
  const error = currenciesError || organizationDefaultsQuery.error;

  return {
    // Loading states (isPending is true during initial load, isLoading includes background refetches)
    isLoading,
    // isLoadingCustomAttributes: customAttributesQuery.isPending,
    isLoadingCurrencies,
    isLoadingOrganizationDefaults: organizationDefaultsQuery.isPending,

    // Error states
    error,
    currencyError: currenciesError,

    // Data
    // customAttributes: customAttributesQuery.data || [],
    currencies,
    organizationDefaults: organizationDefaultsQuery.data,
  };
}
